import { axiosInstance } from "./axios";
import useCustomMutation from 'hooks/useCustomMutation';
import useCustomQuery from 'hooks/useCustomQuery';

const queryKeys = {
    get: (caseId: string) => ['threadsService.get', caseId],
  };


  
  const get = (caseId: string) => {
    return axiosInstance.get(`/threads?CaseId=${caseId}`)
  }

  const useGet = (caseId: string) => {
    return useCustomQuery(queryKeys.get(caseId), () => get(caseId))
  }

  interface IUpdateItem {
    Id: string;
    Kind: number;
  }

  export interface IUpdateList {
    Id: string;
    Items: IUpdateItem[]
  }

  const updateList = (payload: IUpdateList) => {
    return axiosInstance.put('/thread/items', payload)
  }

  const useUpdateList = () => {
    return useCustomMutation(updateList);
  }


export interface ICreateThread {
  CaseId: string;
  Label: string;
    Items: IUpdateItem[]
}

  const createThread = (payload: ICreateThread) => {
    return axiosInstance.post("/thread", payload)
  }

  const useCreateThread = () => {
    return useCustomMutation(createThread)
  }

  export interface IAddToThread {
    threadId: string;
    chatId: string;
    chatKind: number
  }

  const addToThread = (payload: IAddToThread) => {
    return axiosInstance.post(`/thread/${payload.threadId}`, {
      Id: payload.chatId,
      Kind: payload.chatKind
    });
  }

  const useAddToThread = () => {
    return useCustomMutation(addToThread);
  }

  export interface IDeleteFromThread {
    threadId: string;
    chatId: string;
    chatKind: number
  }


  const deleteFromThread = (payload: IDeleteFromThread) => {
    return axiosInstance.delete(`/thread/${payload.threadId}`, {
      data: {

        Id: payload.chatId,
        Kind: payload.chatKind
      }
    });
  }

  const useDeleteFromThread = () => {
    return useCustomMutation(deleteFromThread)
  }

  export interface IMove {
    SourceId: string;
    TargetId: string;
    ItemId: string;
    Kind: number
  }

  const move = (payload: IMove) => {
    return axiosInstance.post('/thread/move', payload)
  }

  const useMove = () => {
    return useCustomMutation(move);
  }

  export default {
    useGet,
    useUpdateList,
    useCreateThread,
    useAddToThread,
    useDeleteFromThread,
    useMove
  } 